import { combineReducers } from "redux";
import userReducer from "./userReducer";
import alertReducer from "./alertReducer";
import productReducer from "./productReducer";
import allUsersReducer from "./allUsersReducer";
import cartReducer from "./cartReducer";
import ordersReducer from "./ordersReducer";
import categoryReducer from "./categoryReducer";
import thanhToanReducer from "./thanhToanReducer";

const myReducers = combineReducers({
    user: userReducer,
    alert: alertReducer,
    products: productReducer,
    users : allUsersReducer,
    cart : cartReducer,
    orders : ordersReducer,
    category : categoryReducer,
    thanhtoan : thanhToanReducer
})

export default myReducers;